import React, { useEffect, useLayoutEffect } from "react";
import Logo, { LogoType } from "../../Components/Logo/Logo";
import arrowLeft from "../../assets/icons/arrow-left.svg";
import "./PrivacyPolicyPage.css";
import { useLocation, useNavigate } from "react-router-dom";

interface PrivacyPolicyProps {
  privacyPolicy: string;
}

const PrivacyPolicyPage: React.FC<PrivacyPolicyProps> = ({ privacyPolicy }) => {
  useEffect(() => {
    const originalColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#FFFFFF";

    return () => {
      document.body.style.backgroundColor = originalColor;
    };
  }, []);

  const location = useLocation();
  const navigate = useNavigate();

  const onBackButtonClick = () => {
    navigate(window.location.pathname.replace("/privacy-policy", ""));
  };

  // scroll to top of page after a page transition.
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  return (
    <div className="policy-background flex min-h-screen pl-4 pr-4 pb-4 justify-center">
      <div className="large-layout w-full text-left">
        <div className="sticky top-0 z-10 pt-4">
          <button
            className="back-button-privacy-policy mb-5"
            onClick={onBackButtonClick}
          >
            <div className="flex flex-row gap-2">
              <img src={arrowLeft} alt="Back" />
              <p className="button-text">Back</p>
            </div>
          </button>
        </div>
        <Logo type={LogoType.Horizontal} />
        <div
          className="privacy-policy"
          dangerouslySetInnerHTML={{ __html: privacyPolicy }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
